module.exports = __webpack_public_path__ + "assets/asset_warning.5079568e.svg";